import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import styled from 'styled-components';

import { breakpoints, media } from '@/shared/components';
import { COLORS } from '@/shared/constants/colors';
import { Icon } from '@/shared/uikit/Icon';
import { Button } from '@/shared/uikitV2/Button';
import { useModalsStore } from '@/widgets/modals/modals.store';
import { CaseCreatedModalProps } from '@/widgets/modals/types';

import { ModalContainerV2 } from '../../interwill/containers/ModalContainerV2';

export const CaseCreatedModal: FC<CaseCreatedModalProps> = ({ caseData, openChat }) => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'caseCreated' });
  const modals = useModalsStore();
  const onClick = () => {
    modals.closeModal();
    if (openChat) {
      modals.openModal({
        type: 'VfoChatModal',
      });
    }
  };

  return (
    <ModalContainerV2 pinBottom closable={false}>
      <Container>
        <IconWrapper>
          <Icon name="folders" size="s24" />
        </IconWrapper>
        <Title>{t('title')}</Title>
        <div>
          <div>{t('text1')}</div>
          <div>
            {t('text2', {
              caseName: caseData.title,
            })}
          </div>
          <div>{t('text3')}</div>
        </div>
      </Container>
      <Buttons>
        <Button size="middle" onClick={onClick}>
          {t('done')}
        </Button>
      </Buttons>
    </ModalContainerV2>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  text-align: center;
  font-size: 14px;
  padding: 4px 0 32px;
`;

const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: auto;
  width: 100%;

  ${media.md}, ${breakpoints.sm} {
    flex-direction: column-reverse;
    gap: 8px;

    button {
      width: 100%;
    }
  }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  color: ${COLORS.systemForest200};
  background: ${COLORS.systemForest100};
  border-radius: 50%;
`;

const Title = styled.b`
  font-size: 22px;
`;
